import UserAvatarComponent from "./UserAvatar.component";

export default UserAvatarComponent;
